import script from "./SysPermissionManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SysPermissionManagement.vue?vue&type=script&setup=true&lang=js"

import "./SysPermissionManagement.vue?vue&type=style&index=0&id=71d60a5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d60a5a"]])

export default __exports__